class PageManual extends HTMLElement {
  constructor() {
    super()
    this.isMobileQuery = window.matchMedia(theme.config.mediaQuerySmall)
    this.isMobileQuery.addEventListener('change', this.onMediaQueryChanged.bind(this))
    this.onWindowResizeListener = theme.utils.throttle(this.onWindowResize.bind(this))
    this.topSections = this.getAllPreviousElements(this.closest('.shopify-section'))

    this.querySelectorAll('.manual-list .manual-list__item').forEach(item => {
      item.addEventListener('click', this.onManualItemClick.bind(this))
    })
    this.initIndexContent()
    this.initScrollHighlight(this.querySelector('.manual-content'))

    if (this.isMobileQuery.matches) {
      this.manualListDetails.removeAttribute('open')
    }

    this.initContentVideo()
  }

  get header() {
    return document.querySelector('header.header')
  }

  get contentContainer() {
    return this.querySelector('.manual-content')
  }

  get defaultContent() {
    return this.querySelector('.manual-content__item.default-content')
  }

  get manualListSummary() {
    return this.querySelector('.manual-list-side summary')
  }

  get manualListSummaryText() {
    return this.querySelector('.manual-list-side summary span')
  }

  get manualListDetails() {
    return this.querySelector('.manual-list-side')
  }

  get activedManualListItem() {
    return this.querySelector('.manual-list__item.active')
  }

  connectedCallback() {
    window.addEventListener('resize', this.onWindowResizeListener)
    this.onWindowResize()
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onWindowResizeListener)
  }

  onMediaQueryChanged() {
    if (this.isMobileQuery.matches) {
      this.manualListDetails.removeAttribute('open')
    } else {
      this.manualListDetails.setAttribute('open', '')
    }
  }

  getAllPreviousElements(element) {
    const previousElements = [];
    let currentElement = element.previousElementSibling;
    
    while (currentElement) {
        previousElements.unshift(currentElement); // 添加到数组开头以保持DOM顺序
        currentElement = currentElement.previousElementSibling;
    }
    
    return previousElements;
  }

  /**
   * 从页面内容里提取h2元素作为索引
   */
  initIndexContent() {
    const activePageId = this.activedManualListItem?.getAttribute('page-id')
    const indexContainer = this.querySelector('.manual-index')
    this.querySelectorAll('.manual-content__item').forEach((content, index) => {
      const pageId = content.getAttribute('page-id')
      const indexHeadingList = this.indexAndCollectH2Elements(content)
      if (indexHeadingList.length > 0) {
        const indexList = document.createElement('div')
        indexList.classList.add('manual-index__list')
        indexList.setAttribute('page-id', pageId)
        indexContainer.appendChild(indexList)
        if (activePageId == pageId) {
          indexList.classList.add('active')
        }
        let i = 0
        for (const indexHeading of indexHeadingList) {
          const indexItem = document.createElement('div')
          indexItem.classList.add('manual-index__item', 'level-' + indexHeading.level)
          indexItem.setAttribute('index-num', i++)
          indexItem.setAttribute('page-id', pageId)
          indexItem.textContent = indexHeading.text
          indexItem.addEventListener('click', this.onIndexNavItemClick.bind(this))
          indexList.appendChild(indexItem)
        }
      }
    })

    if (this.defaultContent) {
      this.querySelector(`.manual-index__list[page-id="${this.defaultContent.getAttribute('page-id')}"]`)?.classList.add('active')
    }
  }

  indexAndCollectH2Elements(container) {
    const headingElements = container.querySelectorAll('h2,h3');
    const headingContents = [];
    headingElements.forEach((heading, index) => {
      let level
      if (heading.tagName == 'H2') {
        level = 0
      } else if (heading.tagName == 'H3') {
        level = 1
      }
      heading.setAttribute('index-num', index);
      headingContents.push({
        text: heading.textContent.trim(),
        level: level
      });
    });
    return headingContents;
  }

  /**
   * 联动内容和索引，使内容滚动时，对应的索引元素高亮。
   * @param {*} container
   * @param {*} navContainer 
   */
  initScrollHighlight(container) {
    // 添加滚动监听
    container.addEventListener('scroll', theme.utils.throttle(() => {

        const elements = Array.from(this.querySelectorAll('.manual-content__item.active [index-num]'))

        // 获取容器A的顶部位置
        const containerTop = container.getBoundingClientRect().top;
        
        // 找出当前最靠近顶部的h2元素
        let activeIndex = -1;
        elements.forEach(el => {
            const rect = el.getBoundingClientRect();
            // 当h2顶部接近或超过容器顶部时
            if (rect.top - containerTop <= 60) {
                activeIndex = Math.max(activeIndex, parseInt(el.getAttribute('index-num')));
            }
        });
        
        const navItems = Array.from(this.querySelectorAll('.manual-index__list.active .manual-index__item'))
        // 更新导航项active状态
        navItems.forEach((item, index) => {
            if (index === activeIndex) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }));
    
    // 初始触发一次
    container.dispatchEvent(new Event('scroll'));
  }

  onIndexNavItemClick(e) {
    const pageId = e.target.getAttribute('page-id')
    const indexNumber = e.target.getAttribute('index-num')
    const scrollTarget = this.querySelector(`.manual-content__item[page-id="${pageId}"] [index-num="${indexNumber}"]`)
    if (scrollTarget) {
      this.contentContainer.scrollTo({
        top: scrollTarget.offsetTop,
        behavior: 'smooth'
      });
    }
  }

  onWindowResize() {
    if (!this.isMobileQuery.matches) {
      let h = 0
      this.topSections.forEach(s => {
        h += s.getBoundingClientRect().height
      })
      h += this.header.getBoundingClientRect().height
      const height = window.innerHeight - h
      this.style.height = height + 'px'
    } else {
      this.style.height = 'auto'
    }
  }

  onManualItemClick (e) {
    if (!e.target.classList.contains('active')) {

      this.defaultContent?.classList.add('hidden')

      this.querySelector('.manual-list__item.active')?.classList.remove('active')
      e.target.classList.add('active')

      const pageId = e.target.getAttribute('page-id')
      this.querySelector('.manual-content__item.active')?.classList.remove('active')
      this.querySelector(`.manual-content__item[page-id="${pageId}"]`)?.classList.add('active')

      this.querySelector('.manual-index__list.active')?.classList.remove('active')
      this.querySelector(`.manual-index__list[page-id="${pageId}"]`)?.classList.add('active')

      this.manualListSummaryText.textContent = e.target.textContent

      this.contentContainer.scrollTop = 0
    } else {
      e.target.classList.remove('active')
      this.querySelector('.manual-content__item.active')?.classList.remove('active')
      this.querySelector('.manual-index__list.active')?.classList.remove('active')
      this.defaultContent?.classList.remove('hidden')
      if (this.defaultContent) {
        this.querySelector(`.manual-index__list[page-id="${this.defaultContent.getAttribute('page-id')}"]`)?.classList.add('active')
      }
      this.manualListSummaryText.textContent = this.manualListSummary.dataset.unselectText
    }

    if (this.isMobileQuery.matches) {
      this.manualListDetails.removeAttribute('open')
    }
  }

  /**
   * 查找页面内容里的特殊视频标记，为其创建视频标签。
   * 查找blockquote标签，找到里面的shopify视频地址。
   */
  initContentVideo() {
    const createVideo = url => {
      const video = document.createElement("video");
      video.src = url;
      video.autoplay = false;
      video.muted = false;
      video.loop = false;
      video.playsInline = true;
      video.controls = true
      return video
    }
    this.contentContainer.querySelectorAll('blockquote').forEach(bq => {
      const videoUrl = this.findFirstShopifyVideoElement(bq)
      if (videoUrl) {
        const mediaVideo = createVideo(videoUrl)
          bq.replaceWith(mediaVideo)
      }
    })
  }

  findFirstShopifyVideoElement(parentElement) {
    // 使用 TreeWalker 高效遍历 DOM
    const treeWalker = document.createTreeWalker(
      parentElement,
      NodeFilter.SHOW_ELEMENT || NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          // 检查是否包含目标字符串
          if (node.textContent && node.textContent.includes('cdn.shopify.com/videos')) {
            return NodeFilter.FILTER_ACCEPT;
          }
          return NodeFilter.FILTER_SKIP;
        }
      }
    );

    // 获取第一个匹配的节点
    const firstMatch = treeWalker.nextNode();
    return firstMatch ? firstMatch.textContent.trim() : null;
  }
}
customElements.define('page-manual', PageManual);